export type LanguageOption = {
  value: string;
  label: string;
};

export function sortLanguageOptionsForDisplay<T extends LanguageOption>(
  options: readonly T[],
  currentLanguage: string | null | undefined,
  locale: string = 'ru'
): T[] {
  const normalizedCurrent = currentLanguage?.split('-')[0] ?? '';
  const collator = new Intl.Collator(locale, {
    sensitivity: 'base',
    numeric: true,
  });

  return [...options].sort((left, right) => {
    const leftIsCurrent = left.value === normalizedCurrent;
    const rightIsCurrent = right.value === normalizedCurrent;

    if (leftIsCurrent && !rightIsCurrent) return -1;
    if (!leftIsCurrent && rightIsCurrent) return 1;

    return collator.compare(left.label, right.label);
  });
}
